import { db } from '@/firebase/firebaseConfig'
import _ from  'lodash-core'
const algoliasearch = require('algoliasearch')

const client = algoliasearch('LDIZ2B1ORC', 'cb5732ac3471ae6aeefa68aa22d1ea7e')
const index = client.initIndex('business')

function parseAlgoliaData(item) {
  let returnData = _.pick(item, [
    'id',
    'name',
    'titleId',
    'titleEn',
    'excerptId',
    'excerptEn',
    'bannerUrl',
    'address',
    'counter',
    'email',
    'phone',
    'logoUrl',
    'thumbnailUrl',
    'province',
    'regency',
    'district',
    'village',
    'slug',
    'socmedLink',
    'workHour',
    'author',
    'status',
    'contractNumber',
    'dateRegister',
    'dateExpired',
    'dateRenewal',
    'priceRegister',
    'priceRenewal',
    'billingCycle',
    'isDeleted'
  ])
  returnData.objectID = item.id
  returnData.category = _.pick(item.category, ['nameId', 'nameEn', 'iconUrl', 'backgroundColor'])
  returnData.subcategory = _.pick(item.subcategory, ['nameId', 'nameEn', 'iconUrl', 'backgroundColor'])
  return returnData
}

const module = {
  firestorePath: 'business/{businessId}',
  firestoreRefType: 'doc', // or 'doc'
  moduleName: 'businessDoc',
  statePropName: 'data',
  namespaced: true, // automatically added
  preventInitialDocInsertion: true,

  sync: {
    defaultValues: {
      id: '',
      category: {},
      subcategory: {},
      author: {},
      sales: {},

      sourceId: '',
      contractNumber: '',
      slug: '',

      logoUrl: '',
      thumbnailUrl: '',
      bannerUrl: '',

      name: '',
      titleId:'',
      titleEn: '',
      descriptionId: '',
      descriptionEn: '',
      excerptId: '',
      excerptEn: '',

      email: '',
      phone: '',
      address: '',
      siteUrl: '',
      workHour: {},
      socmedLink: {
        facebook: '',
        instagram: '',
        twitter: '',
        whatsapp: ''
      },
      counter: {
        likes: 0,
        hits: 0,
        posts: 0
      },

      maps: {
        q: ''
      },

      dateRegister: null,
      dateExpired: null,
      dateRenewal: null,
      priceRegister: 0,
      priceRenewal: 0,
      billingCycle: 12,

      status: '',
      isDeleted: false
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    data: state => {
      if (!state.data.workHour) state.data.workHour = {}

      const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ]

      days.forEach((i) => {
        if(!state.data.workHour[i]) {
          state.data.workHour[i] = {}
        }
      })

      if (!state.data.maps) state.data.maps = {}
      if (!state.data.maps.q) state.data.maps.q = ''

      return state.data
    }
  },
  mutations: {},
  actions: {
    setData({}, payload) {
      let data = parseAlgoliaData(payload)
      return db.collection('business').doc(data.id).update(payload)
        .then(() => index.saveObject(data))
    },
    insertData({}, payload) {
      const ref = db.collection("business").doc()
      payload.id = ref.id
      return ref.set(payload)
        .then(() => index.saveObject(parseAlgoliaData(payload)))
        .then(() => parseAlgoliaData(payload))
    },
    deleteData({}, payload) {
      return db.collection('business').doc(payload).update({ isDeleted: true })
        .then(() => index.deleteObject(payload))
        .then(() => payload)
    },
    search({}, payload) {
      return index.search(payload)
    }
  },
}

export default module
